import { apiClient } from './apiClient';

export const fetchColumnDefinitions = async () => {
    try {
        const response = await apiClient.get('/claims/reclamos?describe=true');
        return response.data;
    } catch (error) {
        throw error;
    }
};

/*
    GET obtiene los datos de la tabla y las filtra para mostrar solo las ready to claim TODO: cambiar endpoint para que envíe solo los datos necesarios (y no todo)
 */
export const fetchData = async () => {
    try {
        const response = await apiClient.get('/claims/reclamos');
        return response.data //.filter(item => item.status === "Ready to Claim");
    } catch (error) {
        throw error;
    }
};

export const updateData = async (dataToUpdate) => {
    try {
        let url = '/claims/updateone';
        const response = await apiClient.post(url, dataToUpdate)

        console.log("response", response)

        // const response2 = await fetch('/claims/updateone', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(dataToUpdate),
        // });

        return response;
    } catch (error) {
        throw error;
    }
}

export const crearReclamo = async (crearReclamoIds) => {
    try {
        let url = '/claims/reclamo';
        return await apiClient.post(url, crearReclamoIds);
    } catch (error) {
        throw error;
    }
}